interface FallbackScatterPoint {
    x: number;
    y: number;
}

interface FallbackScatterSeries {
    id: string;
    data: FallbackScatterPoint[];
}

const FALLBACK_SERIES = [
    { id: 'Group A', seed: 17 },
    { id: 'Group B', seed: 41 },
    { id: 'Group C', seed: 73 },
] as const;

const createFallbackPoint = (seed: number, index: number): FallbackScatterPoint => {
    const x = (seed * (index + 3) + index * index * 7) % 101;
    const y = (seed * (index + 11) + index * 23 + (index % 5) * 17) % 121;

    return { x, y };
};

export const fallbackScatterPlotData: FallbackScatterSeries[] = FALLBACK_SERIES.map(({ id, seed }) => ({
    id,
    data: Array.from({ length: 48 }, (_, index) => createFallbackPoint(seed, index)),
}));
